import { ResponsiveGrid } from "@adobe/aem-react-editable-components"
import withSSRModel from "hoc-lib/ssrModelMapper"
import MAPPED_COMPONENTS from "../import-components-shared"

// https://github.com/adobe/aem-react-editable-components/tree/master/src/components
const CustomCoreContainer = (props) => (
  <ResponsiveGrid
    key={props.cqPath}
    model={props}
    itemPath={process.env.NEXT_PUBLIC_AEM_MODEL_ITEM_PATH}
    components={{
      ...MAPPED_COMPONENTS,
    }}
  />
)

const WrappedCustomContainer = withSSRModel(CustomCoreContainer)

export default WrappedCustomContainer
